'use strict'

module.exports = function isOnline (self) {
  return () => {
    return Boolean(self._bitswap && self._libp2pNode)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/ipfs/src/core/components/is-online.js
// module id = 521
// module chunks = 0